import { useEffect, useRef } from "react";
import { usePublicLiveStore } from "../../store";

const isDocumentFullscreen = () => Boolean(document.fullscreenElement);

export const useFullscreenBehavior = () => {
  const {
    isFullscreen,
    actions: { setIsFullscreen },
  } = usePublicLiveStore();
  const elementRef = useRef<HTMLDivElement>(null);
  const toggleFullscreen = () => {
    const player = elementRef.current;
    if (!player) {
      return;
    }
    if (isDocumentFullscreen()) {
      void document.exitFullscreen();
    } else {
      void player.requestFullscreen();
    }
  };

  useEffect(() => {
    const updateFullscreenState = () => {
      setIsFullscreen(isDocumentFullscreen());
    };
    document.addEventListener("fullscreenchange", updateFullscreenState);

    return () => {
      document.removeEventListener("fullscreenchange", updateFullscreenState);
    };
  }, [setIsFullscreen]);

  return {
    elementRef,
    toggleFullscreen,
    isFullscreen,
  };
};
